import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, Link } from "gatsby-plugin-intl";

const Common_button_details = ({buttonLink, buttonID, buttonDisplayName, buttonBgColor, buttonTextColor, buttonHoverBgColor, buttonHoverTextColor}) => {

    let customBgColor = buttonBgColor;
    let customHoverBgColor = buttonHoverBgColor;
    let customHoverTextColor = buttonHoverTextColor;
    let customTextColor = buttonTextColor;

    return (
        <Link
            to={buttonLink}
            data-gumroad-single-product="true"
            className={"block w-full text-center rounded-full p-2 md:p-4 md:text-xl leading-6 font-bold focus:outline-none focus:shadow-outline transition ease-in-out duration-150 " + " " + customBgColor + " " + customHoverBgColor + " " + customHoverTextColor + " " + customTextColor}
            id={buttonID}
            >
            <FormattedMessage id={buttonDisplayName} />
        </Link>
    );
}

Common_button_details.propTypes = {
    buttonLink: PropTypes.string,
    buttonID: PropTypes.string,
    buttonDisplayName: PropTypes.string,
    buttonBgColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
    buttonHoverBgColor: PropTypes.string,
    buttonHoverTextColor: PropTypes.string
  };
  
  export default Common_button_details;